import { render, staticRenderFns } from "./info5.vue?vue&type=template&id=24e9dc24"
import script from "./info5.vue?vue&type=script&lang=js"
export * from "./info5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports